// Determine the host based on environment
const getHost = () => {
    // In production, use the current domain without port
    if (process.env.REACT_APP_MODE === "RELEASE" ) {
        return window.location.protocol + '//' + window.location.hostname;
    }
    
    // In development/staging, add port 1235 if not already present
    const currentPort = window.location.port;
    if (currentPort && currentPort !== "80" && currentPort !== "443") {
        // If already has a port (like 3000 for React dev server), use backend port
        return window.location.protocol + '//' + window.location.hostname + ":1235";
    }
    
    // Default case
    return window.location.protocol + '//' + window.location.hostname + ":1235";
}

const HOST = getHost();

export const ENDPOINT_GEN = HOST + "/v1/gen"
export const ENDPOINT_RETRIEVE_GEN = HOST + "/v1/gen/ret"
export const ENDPOINT_RETRIEVE_GEN_META = HOST + "/v1/gen/meta"
export const ENDPOINT_STATUS_GEN = HOST + "/v1/gen/status"
export const ENDPOINT_DOWNLOAD_GEN = HOST + "/v1/gen/dl2"
export const ENDPOINT_DISCARD_GEN = HOST + "/v1/gen/discard"
export const ENDPOINT_CANCEL_GEN = HOST + "/v1/gen/cancel"
export const ENDPOINT_AUTH = HOST + "/v1/auth/req"
export const ENDPOINT_LOGOUT = HOST + "/v1/logout"
export const ENDPOINT_LOAD_SESSION = HOST + "/v1/session"
export const ENDPOINT_UPDATE_SETTINGS = HOST + "/v1/settings/update"
export const ENDPOINT_SETTINGS = HOST + "/v1/settings"
export const ENDPOINT_TEST_CONNECTION = HOST + "/v1/settings/test-connection"
export const ENDPOINT_XML_LIBRARY = HOST + "/v1/xml/library" // Endpoint for listing/getting library files
export const ENDPOINT_SAVE_GEN_TO_LIBRARY = HOST + "/v1/gen/library/save" // New endpoint for saving generated data

// authorization - environment-specific auth servers
const getAuthServer = () => {
    
    // Fallback based on mode
    switch (process.env.REACT_APP_MODE) {
        case "RELEASE":
            return "https://cpass.core1corp.com";
        case "STAGING":
            return "http://54.179.245.7:1234";
        case "DEBUG":
        default:
            return "http://54.179.245.7:1234";
    }
}

const getClientId = () => {
    switch (process.env.REACT_APP_MODE) {
        case "RELEASE":
            return "1736772948474";
        case "STAGING":
            return "1779952492441";
        case "DEBUG":
        default:
            return "1779952492441";
    }
}

export const AUTH_SERVER = getAuthServer();
export const APPID = "cocree"
export const CLIENT_ID = getClientId();

// Debug logging
if (process.env.REACT_APP_MODE !== "RELEASE") {
    console.log("Build Mode:", process.env.REACT_APP_BUILD_MODE);
    console.log("App Mode:", process.env.REACT_APP_MODE);
    console.log("Auth Server:", AUTH_SERVER);
    console.log("API Host:", HOST);
}

// Error message mappings for user-friendly display
export const ERROR_MESSAGES: Record<number, {message: string, action: string}> = {
    404: {
        message: "The requested resource could not be found",
        action: "Please verify your settings and try again"
    },
    500: {
        message: "The server encountered an unexpected error",
        action: "Please try again later or contact support"
    },
    502: {
        message: "Invalid response from the server", 
        action: "Please try again in a few moments"
    },
    503: {
        message: "The service is temporarily unavailable",
        action: "Please try again later"
    },
    504: {
        message: "The server is taking too long to respond",
        action: "Please try again or contact support if this persists"
    },
    0: {
        message: "Unable to connect to the server",
        action: "Please check your internet connection and try again"
    }
};

export const DEFAULT_ERROR = {
    message: "An unexpected error occurred",
    action: "Please try again or contact support"
};
